import { Route, Routes } from 'react-router-dom';
import { copy } from '../copy/es';
import { PortalPage } from './PortalPage';

/** Third-party portal, addressed by /p/{token}. No sign-in ever (HU-1). */
export function PortalApp() {
  return (
    <Routes>
      <Route path=":token" element={<PortalPage />} />
      <Route
        path="*"
        element={<p className="p-8 text-center text-gray-600">{copy.comun.noEncontrado}</p>}
      />
    </Routes>
  );
}
